import React, { Component } from "react";
import { connect } from "react-redux";
import { Section } from "@sunwing/components";
import View from "components/quote/view/index";
import quote from "services/quote/quote.service";
import PageHeader from "components/common/pageHeader/pageHeader";
import { withRouter } from "utilities/withRouter";

class GenerateQuote extends Component {
    
    componentDidMount() {
        const { quoteNumber } = this.props.params;
        if (quoteNumber) {
            this.loadQuote(quoteNumber);
        }
    }

    loadQuote = async (quoteNumber) => {
        this.props.showLoadingSpinner(true);
        const response = await this.props.dispatch(quote.get(quoteNumber));
        console.log("letter", response);
        this.props.showLoadingSpinner(false);
    };

    render() {

        let { quote, groupTypes } = this.props;


        const showEventLogo = (quote?.data?.groupInformation?.eventName ?? "") !== "";

        return (
            <div className="row view-quote">
                <div className="row margin-bottom-4x ">
                    <Section>
                        <div className="page-main-container margin-bottom-1x">
                            <PageHeader isGeneratedQuotePage={true} showEventLogo={showEventLogo} />
                        </div>
                    </Section>
                    <View quote={quote} navigate={this.props.navigate} groupTypes={groupTypes} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    quote: state.quote,
    groupTypes: state.groupTypes
});

export default connect(mapStateToProps)(withRouter(GenerateQuote));